/* eslint-disable */
import 'jquery.cookie';
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';
import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';
import './css/atlas-header-withMenu.scss';
import './css/atlas-page-sections.css';
import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
/*import AtlasCommentsView from './View/comments/Comments';*/
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import SocialButtons from "@/js/desktop/components/social-btns";
import SearchPageView from "@/js/desktop/View/SearchPage";
import SearchPageReviewsModel from './Model/SearchPageReviewsModel';

var Controller = AbstractSearchController.extend({
	initSocialButtons() {
		new SocialButtons({
			el: '.social-btns'
		});
	},
	/*
	TODO:// task PROD-247; оставил так как функционал может понадобиться в будующем
	initStaticComments: function() {
		$('body').on('click', '.hotelReviewsLink', function(){
			var $wrapper = $(this).parents('.hotelReviewsWrapper'),
				$container = $('.reviewsContainer', $wrapper),
				hotelId = $(this).data('hotel');

			if(!$wrapper.hasClass('opened')) {
				if(!$wrapper.hasClass('ourComments')) {
					$.ajax({
						url: '/hotel/hotel-top-totels-reviews?id=' + hotelId,
						type: "POST"
					}).done(function(response) {
						if (response.success === true) {
							var tophotelsScript = response.result;
							if(tophotelsScript){
								$('.reviewsContainer').html('');
								$('.hotelReviewsWrapper').removeClass('opened');
								$container.html(tophotelsScript);
								$wrapper.addClass('opened');
								$wrapper.addClass('tophotelsComments');
								var headerTop = $('.headerContainer').offset().top,
									wrapperTop = $wrapper.offset().top;
								if (headerTop > wrapperTop - 150) {
									$('html, body').animate({scrollTop: wrapperTop - 300}, 700);
								}
							}
						} else {
							var element = '#hotelContainerId' + hotelId;
							new AtlasCommentsView({
								el: element + ' .reviewsContainerOur',
								hotelId: hotelId
							});
							$('.hotelReviewsWrapper').removeClass('opened');
							$('.reviewsContainer').html('');
							$wrapper.addClass('opened');
							$wrapper.addClass('ourComments');
							var headerTop = $('.headerContainer').offset().top,
								wrapperTop = $wrapper.offset().top;
							if (headerTop > wrapperTop - 150) {
								$('html, body').animate({scrollTop: wrapperTop - 300}, 700);
							}
						}
					});
				} else {
					$('.hotelReviewsWrapper').removeClass('opened');
					$('.reviewsContainer').html('');
					$wrapper.addClass('opened');
					var headerTop = $('.headerContainer').offset().top,
						wrapperTop = $wrapper.offset().top;
					if (headerTop > wrapperTop - 150) {
						$('html, body').animate({scrollTop: wrapperTop - 300}, 700);
					}
				}
			} else {
				$('.hotelReviewsWrapper').removeClass('opened');
				$('.reviewsContainer').html('');
			}
		});
	},*/
	initSearchPageView() {
		this.view = new SearchPageView({
			el: '#forSearchView',
			searchFormViewModel: this.model,
			/*hotelTemplate: hotelTemplateAtlasReviews,*/
			SearchPageModel: SearchPageReviewsModel,
			dataLayerAnalytics: this.dataLayerAnalytics
		});
	},
	initialize: function() {
		$.removeCookie('requestFromMainPage', {path: '/', domain: 'all'});
		tourCriteriaService.clearTourCriteriaChangedFields();

		AbstractSearchController.prototype.initialize.call(this);
		this.initSocialButtons();
	}
});

$(() => {
	new Controller({
		el: 'body'
	});
});

